import React from "react";
import SliderStyles from "./Slider.module.css";
import person from "Assets/Homepage/Slider-2/person.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";

function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
        <div className={SliderStyles["arrow-right"]} onClick={onClick}>
            <FaArrowRight />
        </div>
    );
}

function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
        <div className={` ${SliderStyles["prev"]}`} onClick={onClick}>
            <FaArrowLeft />
        </div>
    );
}

function Slide() {
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: (dots: any) => (
            <div>
                <ul style={{ margin: "0px" }}> {dots} </ul>
            </div>
        ),
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
    };
    return (
        <div className={SliderStyles["Slide-wrapper"]}>
            <Slider {...settings}>
                <div className={SliderStyles["slider-data"]}>
                    <img src={person} alt="person" />
                    <div className={SliderStyles["Slide-content"]}>
                        <h3>
                            FBAR Filing<span></span>
                        </h3>
                        <p>
                            U.S. citizens, residents, entities (corporations,
                            partnerships, limited liability companies, trusts,
                            and estates), if the aggregate value of all foreign
                            financial accounts exceeds $10,000 at any point
                            during the calendar year.
                        </p>
                        <button className={SliderStyles["viewmore"]}>
                            View More
                        </button>
                    </div>
                </div>
                <div className={SliderStyles["slider-data"]}>
                    <img src={person} alt="person" />
                    <div className={SliderStyles["Slide-content"]}>
                        <h3>
                            FATCA Filing
                            <span></span>
                        </h3>
                        <p>
                            FATCA requires U.S. taxpayers to report specified
                            foreign financial assets if the total value exceeds
                            certain thresholds, in addition to filing regular
                            tax returns.
                        </p>
                        <button className={SliderStyles["viewmore"]}>
                            View More
                        </button>
                    </div>
                </div>
            </Slider>
        </div>
    );
}

export default Slide;
